import type { ContactFormData } from '../types/form-data.types'

export const buildDescription = (formData: ContactFormData): string => {
  const parts: string[] = []

  if (formData.websiteDomain) {
    parts.push(`Website: ${formData.websiteDomain}`)
  }

  if (formData.description) {
    parts.push(formData.description)
  }

  if (formData.selectedLineItemIds?.length > 0) {
    parts.push(`Item IDs: ${formData.selectedLineItemIds.join(', ')}`)
  }

  if (formData.selectedWorkIds?.length > 0) {
    parts.push(`Work IDs: ${formData.selectedWorkIds.join(', ')}`)
  }

  return parts.join('\n')
}
